export default __webpack_public_path__ + "static/media/empty_noti.b5871f03.png";